import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Free-tier indicator chip.
 * Hidden when admin OR subscribed. Tone shifts amber → rose as user approaches/exhausts quota.
 */
export const FreeQuotaChip = ({ subscription, isAdmin, isSubscribed, className, dataTestId = "free-quota-chip" }) => {
    if (isAdmin || isSubscribed) return null;
    if (!subscription) return null;
    const { free_used = 0, free_remaining = 0 } = subscription;
    const quota = free_used + free_remaining;
    if (!quota) return null;

    const exhausted = free_remaining === 0;
    return (
        <Link
            to="/subscribe"
            className={cn(
                "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors",
                exhausted
                    ? "border-rose-200 bg-rose-50 text-rose-700 hover:bg-rose-100"
                    : "border-amber-200 bg-amber-50 text-amber-800 hover:bg-amber-100",
                className
            )}
            data-testid={dataTestId}
        >
            <Sparkles className="h-3 w-3" aria-hidden />
            {exhausted
                ? <>Free trial complete · <span className="underline">Subscribe to continue</span></>
                : <span data-testid={`${dataTestId}-text`}>{free_used} of {quota} free sessions used</span>}
        </Link>
    );
};
